export default "__VITE_ASSET__DdnKqTTG__"